"use client";

import { MessagingProvider } from "@/contexts/messaging-context";
import { MessageChatWidget } from "./MessageChatWidget";
import { MessagesModal } from "./MessagesModal";

interface MessagingLayoutProps {
  children: React.ReactNode;
}

export function MessagingLayout({ children }: MessagingLayoutProps) {
  return (
    <MessagingProvider>
      {children}
      {/* Global messaging components that persist across navigation */}
      <MessageChatWidget />
      <MessagesModal />
    </MessagingProvider>
  );
}